import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useLoadingDialogStore } from '@/stores/useLoadingDialogStore';
import { useSimpleDialogStore } from '@/stores/useSimpleDialogStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const loadingDialogStore = useLoadingDialogStore();
const { active } = storeToRefs(loadingDialogStore);
const simpleDialogStore = useSimpleDialogStore();
const {
	showSimpleDialog,
	simpleDialogMessage,
	simpleDialogTitle
} = storeToRefs(simpleDialogStore);

const layoutComponent = computed(() => route.meta.layout ? defineAsyncComponent(() => import(`@/layouts/${route.meta.layout}.vue`)) : '');

return (_ctx: any,_cache: any) => {
  const _component_va_progress_circle = _resolveComponent("va-progress-circle")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(layoutComponent.value), null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: "routerViewSlot" }))
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_va_modal, {
            modelValue: _unref(active),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(active) ? (active).value = $event : null)),
            class: "loading-dialog",
            "no-dismiss": ""
          }, {
            content: _withCtx(() => [
              _createVNode(_component_va_progress_circle, { indeterminate: "" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _unref(showSimpleDialog),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showSimpleDialog) ? (showSimpleDialog).value = $event : null)),
            class: "simple-dialog"
          }, {
            content: _withCtx(({ ok }) => [
              (!_unref(simpleDialogTitle))
                ? (_openBlock(), _createBlock(_component_va_card_title, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(simpleDialogMessage)), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_va_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(simpleDialogTitle)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_card_content, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(simpleDialogMessage)), 1)
                      ]),
                      _: 1
                    })
                  ], 64)),
              _createVNode(_component_va_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_va_button, { onClick: ok }, {
                    default: _withCtx(() => [
                      _createTextVNode("OK")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})